(function () {
  if (window.__dpCardsInit) return;
  window.__dpCardsInit = true;

  var PROXY_URL = "/apps/discount-prices/discount";
  var formatters = {};

  function fmt(currency, locale, n) {
    var key = (locale || "") + "|" + currency;
    if (!formatters[key]) {
      try { formatters[key] = new Intl.NumberFormat(locale || undefined, { style: "currency", currency: currency }); }
      catch (e) { formatters[key] = { format: function (x) { return x.toFixed(2); } }; }
    }
    return formatters[key].format(n);
  }

  function gidNum(s) { var m = /(\d+)$/.exec(s || ""); return m ? m[1] : null; }

  function scan() {
    var cards = [].slice.call(document.querySelectorAll("[data-dp-card]:not([data-dp-done])"));
    if (!cards.length) return;
    cards.forEach(function (c) { c.setAttribute("data-dp-done", "1"); });

    var ids = {};
    cards.forEach(function (c) {
      var pid = c.getAttribute("data-product-id");
      if (pid) ids[pid] = true;
    });
    var list = Object.keys(ids);
    for (var i = 0; i < list.length; i += 250) {
      request(list.slice(i, i + 250), cards);
    }
  }

  function request(productIds, cards) {
    fetch(PROXY_URL + "?product_ids=" + encodeURIComponent(productIds.join(",")), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products) return;
        cards.forEach(function (card) { apply(card, data.products); });
      })
      .catch(function () { /* leave theme price as fallback */ });
  }

  function apply(card, products) {
    var variants = products["gid://shopify/Product/" + gidNum(card.getAttribute("data-product-id"))];
    if (!variants) return;

    var variantNum = gidNum(card.getAttribute("data-variant-id"));
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      if (gidNum(variants[i].variantId) === variantNum) { match = variants[i]; break; }
    }
    if (!match) {
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].discountedPrice != null) { match = variants[j]; break; }
      }
    }
    if (!match || match.discountedPrice == null || match.discountedPrice >= match.price) return;

    var currency = card.getAttribute("data-currency") || "USD";
    var locale = card.getAttribute("data-locale") || undefined;
    card.innerHTML =
      '<span class="card-product__price dp-card__price">' +
        '<s class="dp-card__original">' + fmt(currency, locale, match.price) + "</s> " +
        '<span class="dp-card__sale">' + fmt(currency, locale, match.discountedPrice) + "</span>" +
      "</span>";
  }

  function boot() {
    scan();
    document.addEventListener("shopify:section:load", function () { setTimeout(scan, 0); });
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; scan(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();